/**
 * Height above ground is drawn compressed. Under a 45-degree orthographic camera a true 60 m
 * puts the canopy a screen and a half above its own shadow, and the shadow is what the player
 * steers by; at this scale the aircraft, the canopy and the spot beneath them share the screen.
 */

export const ALTITUDE_DRAW_SCALE = 0.3;

export const drawnAltitude = (metres: number): number => metres * ALTITUDE_DRAW_SCALE;

/** The level flying things are measured from: the map's nominal ground, not whatever lies under them. */
const FLIGHT_DATUM = 0;
/** Below this true height a falling thing eases off the datum onto the real ground, so it lands ON it. */
const EASE_ONTO_GROUND_BELOW = 12;

/**
 * World height of something `metres` up, over a spot whose terrain height is `ground`. Anything
 * flying holds a level line: measured from the terrain it would dip into every trench and river
 * bed it crossed (only its shadow should do that). In the last few metres it eases onto the real
 * ground, so a canopy or a pod touches down on the terrain rather than above or inside it.
 */
export function flightHeight(ground: number, metres: number): number {
  const k = Math.min(1, Math.max(0, metres / EASE_ONTO_GROUND_BELOW));
  const level = k * k * (3 - 2 * k);
  return ground + (FLIGHT_DATUM - ground) * level + drawnAltitude(metres);
}
